var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"width100 d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"col-lg-6"},[_c('h1',{staticClass:"my-5 mx-auto"},[_vm._v(" 404 ")]),_vm._v(" "),_c('h2',[_vm._v(" Страница не найдена. ")])])])])])
}]

export { render, staticRenderFns }